import config from "@/config";
import router from "./../router";
export default {
  channel(_link, _data) {
    let headers = config.getHeaders();
    let link = config.baselink + _link;
    let req = { headers };
    req.method = _data.method ?? "GET";
    if (_data) {
      req.body = _data.body ?? null;
    }
    return fetch(link, { ...req });
  },
  channelFile(_link, _data) {
    let headers = config.getHeaders();
    let link = config.baselink + _link;
    let req = { headers };
    req.method = _data.method ?? "GET";
    if (_data) {
      req.body = _data.body ?? null;
    }
    const retVal = fetch(link, { ...req });
    retVal
      .then((response) => response.blob())
      .then((blob) => {
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = url;
        a.download = `report ${new Date().toUTCString()}.xlsx`;
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove(); //afterwards we remove the element again
      });
  },
  promiseInterceptor(response) {
    console.log(response);
    if (response.status == "401") {
      localStorage.clear();
      router.push("/login?message=logout");
    } else {
      return response.json();
    }
  },
};
